import request from "@/utils/request";
// 获取菜单列表
export function getBackendApi(params) {
    return request({
        url: "/management/backend",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 大后台转发
export function getManagementApi(params) {
    return request({
        url: "/management",
        method: "POST",
        headers: { secret: true },
        params,
    });
}
// 获取数据
export function getManageDataApi(params) {
    return request({
        url: "/manage/get_data",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 获取百度城市数据
export function getbdAreaApi(params) {
    return request({
        url: "/transfer/get_area",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 获取区域POI
export function getAreaPoiApi(params) {
    return request({
        url: "/transfer/get_poi",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 数据接口
export function getDataApi(params) {
    return request({
        url: "/transfer/get_data",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 报告详情
export function getreportDetailsApi(params) {
    return request({
        url: "/transfer/details",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 获取任一面城市信息
export function getCityApi(params) {
    return request({
        url: "/transfer/get_city",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 请求任一面分析
export function getareaAnalysisApi(params) {
    return request({
        url: "/transfer/get_result",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 任一面分析记录
export function getareaAnalysislistApi(params) {
    return request({
        url: "/analysis/list",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 城市洞察获取点位
export function getgridApi(params) {
    return request({
        url: "/transfer/get_grid",
        method: "get",
        headers: { secret: false },
        params,
    });
}
// 城市洞察获取ID
export function getscenicApi(params) {
    return request({
        url: "/transfer/get_scenic",
        method: "get",
        headers: { secret: false },
        params,
    });
}
export function getcountApi(params) {
    return request({
        url: "/count_data",
        method: "get",
        headers: { secret: true },
        params,
    });
}
export function monthData(params) {
    return request({
        url: "/month_data",
        method: "get",
        headers: { secret: true },
        params,
    });
}
export function countAll(params) {
    return request({
        url: "/count_all",
        method: "get",
        headers: { secret: true },
        params,
    });
}
export function countWarning(params) {
    return request({
        url: "/count_warning",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 旅店每日价格统计价格导出
export function getHotelPriceoutputApi(params) {
    return request({
        url: "/formCenter/house_stay_rate_tax/output",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 行业营收税收报表纳税限额导出
export function getTaxlimittaxoutputApi(params) {
    return request({
        url: "/formCenter/tax_limit_tax/output",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 行业营收税收报表升限导出
export function getTaxrisetaxoutputApi(params) {
    return request({
        url: "/formCenter/tax_rise_tax/output",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 入住率导出
export function getOccupancyratestatisticstaxoutputApi(params) {
    return request({
        url: "/formCenter/occupancy_rate_statistics_tax/output",
        method: "get",
        headers: { secret: true },
        params,
    });
}
// 行业评论报表导出
export function getBusinessreviewreporttaxoutputApi(params) {
    return request({
        url: "/formCenter/business_review_report_tax/output",
        method: "get",
        headers: { secret: true },
        params,
    });
}
